import React from 'react'
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

const porto3 = () => {
  const projects = [
    { image: "/images/porto3/porto3-0.jpg" },
    { image: "/images/porto3/porto3-1.jpg" },
    { image: "/images/porto3/porto3-2.jpg" },
    { image: "/images/porto3/porto3-3.jpg" },
    { image: "/images/porto3/porto3-4.jpg" },
    { image: "/images/porto3/porto3-5.jpg" },
    { image: "/images/porto3/porto3-6.jpg" },
    { image: "/images/porto3/porto3-7.jpg" },
    { image: "/images/porto3/porto3-8.jpg" },
    { image: "/images/porto3/porto3-9.jpg" },
    { image: "/images/porto3/porto3-10.jpg" },
    { image: "/images/porto3/porto3-11.jpg" },
    { image: "/images/porto3/porto3-12.jpg" },
 
  ];

  return (
    <div className="py-10">
      <Swiper
        modules={[Navigation, Pagination, Autoplay]}
        spaceBetween={30}
        slidesPerView={1}
        navigation
        pagination={{ clickable: true }}
        autoplay={{ delay: 3000, disableOnInteraction: false }}
        breakpoints={{
          768: { slidesPerView: 2 },
          1024: { slidesPerView: 3 },
        }}
        className="rounded-2xl"
      >
        {projects.map((project, index) => (
          <SwiperSlide key={index}>
            <div className="overflow-hidden rounded-2xl shadow-lg group relative transition-transform duration-500 hover:scale-105 hover:shadow-2xl">
              <img
                src={project.image}
                loading="lazy"
                alt="Portfolio"
                className="w-full h-80 object-cover transition-transform duration-500 group-hover:scale-110"
              />
              {/* Overlay on hover */}
              <div className="absolute inset-0 bg-black/30 opacity-0 group-hover:opacity-100 transition-opacity duration-500 flex items-center justify-center">
                {/* يمكن إضافة أي أيقونات أو نص هنا */}
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  )
}

export default porto3;
